import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: 100000,
    withCredentials: true,
});


export const getSingleProperty = async (id) => {
    try {
        const response = await api.get(`user/getSingleProperty/${id}`);
        return {
            success: true,
            property: response.data.property,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message
        }
    }
}


export const getAllProperties = async (params = {}) => {
    try {
        const response = await api.get('/user/getAllProperties', { params });
        return {
            success: true,
            properties: response.data.properties,
        };
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error
        }
    }
}

export const updatePropertyRoom = async (formData, propertyId) => {
    try {
        const response = await api.post(`user/updatePropertyRoom/${propertyId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return {
            success: false,
            message: response.data.message,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message
        }
    }
}

export const bookPropertyRoom = async (propertyId, roomId, formData, number, medium, type) => {
    try {
        const payload = {
            ...formData,
            number,
            medium,
        };
        const response = await api.post(`user/bookProperty/${propertyId}/room/${roomId}/${type}`, payload);
        return {
            success: true,
            message: response.data.message,
        }
    } catch (error) {
        return {
            success: false,
            error: error.message,
        }
    }
}

export const bookProperty = async (propertyId, formData) => {
    try {
        const response = await api.post(`user/bookProperty/${propertyId}`, formData);
        return {
            success: true,
            message: response.data.message,
        }
    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.error || error.message,
        }
    }
}

export const getPropertyRoomBookings = async (roomId) => {
    try {
        const response = await api.get(`user/getPropertyRoomBookings/${roomId}`);
        return {
            success: true,
            bookings: response.data.bookings,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

export const updatePropertyBookingStatus = async (roomId, bookingId, status) => {
    try {
        const response = await api.put(`user/update/${roomId}/Booking/${bookingId}/status/${status}`, {});
        return {
            success: true,
            message: response.data.message,
        }
    } catch (error) {
        return {
            success: false,
            error: error.message,
        }
    }
}

export const getUserPropertyBookings = async () => {
    try {
        const response = await api.get('user/getPropertyBookings');
        return {
            success: true,
            propertyBookings: response.data.propertyBookings,
            purchaseBookings: response.data.purchaseBookings,
        }
    } catch (error) {
        return {
            success: false,
            error: error.message,
        }
    }
}

export const getDashboardStats = async () => {
    try {
        const response = await api.get('/user/stats');
        return {
            success: true,
            metrics: response.data.data.metrics,
            properties: response.data.data.properties,
            activity: response.data.data.activity,
            occupancyData: response.data.data.occupancyData,
            revenueData: response.data.data.revenueData,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

export const getDashboardMetrics = async () => {
    try {
        const response = await api.get('/user/getDashboardMetrics');
        return {
            success: true,
            metrics: response.data.metrics,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

export const getDashboardProperties = async (limit = 3) => {
    try {
        const response = await api.get('/user/getDashboardProperties', {
            params: { limit }
        });
        return {
            success: true,
            properties: response.data.properties,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

export const getDashboardActivity = async (limit = 3) => {
    try {
        const response = await api.get('/user/getDashboardActivity', {
            params: { limit }
        });
        return {
            success: true,
            activity: response.data.activity,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

export const getOccupancyStats = async (timeRange = 'This Month') => {
    try {
        const response = await api.get('/user/getOccupancyStats', {
            params: { range: timeRange }
        });
        return {
            success: true,
            occupancyData: response.data.occupancyData,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

export const getRevenueTrend = async (timeRange = 'Last 6 Months') => {
    try {
        const response = await api.get('/user/getRevenueTrend', {
            params: { range: timeRange }
        });
        return {
            success: true,
            revenueData: response.data.revenueData,
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

export const generateDashboardReport = async (reportType = 'pdf', dateRange = 'monthly') => {
    try {
        const response = await api.get('/user/generateDashboardReport', {
            params: {
                type: reportType,
                range: dateRange
            },
            responseType: reportType === 'pdf' ? 'blob' : 'json'
        });

        if (reportType === 'pdf') {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `dashboard-report-${new Date().toISOString().split('T')[0]}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }

        return {
            success: true,
            message: reportType === 'pdf' ? 'Report downloaded successfully' : 'Report generated successfully',
            data: response.data
        }
    } catch (error) {
        if (error.response && error.response.data.redirectTo) {
            window.location.href = error.response.data.redirectTo + '?from=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return {
            success: false,
            error: error.message,
        }
    }
}

// Alias exports with correct casing for component imports
export const UpdatePropertyRoom = updatePropertyRoom;
export const getPropertys = getAllProperties;
export const getProperty = getSingleProperty;
